/****************ELEMENTS*****************/
//this obj define, the actions realeted to each
//th>table header and td
const timeDate = require("../../../../../js-handler/time-date");

function getTdDataDetail(dest, entity, dbid) {
  return `data-detail='{ 
      "click": [ 
        {"dest":"ripple"},
        {"dest":"${dest}", "elem":"fullcont", "id":"${dest}-fullcont", "act":"selectOne", "entity":"${dest}", "dbid":"${dbid}"}
      ],
      "clickRight": [ 
        {"dest":"clientPayments", "elem":"dt", "act":"trMenu", "id":"trMenu", "entity":"clientPayments", "dbid":"${dbid}"}
      ] 
  }'`;
}

export const tableDetail = {

  entity: "clientPayments", //name table on the db
  dest: "clientPayments", //name of the entity on the system

  //action for body
  //left click, directly to the fullcont
  tdDataDetail: `data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"clientPayments", "elem":"page", "act":"removeFc"}  ],
                                
                                 "clickRight": [{"dest":"purchase", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"purchase", "dbid": "#dbid" } ]  }'`,

  // andry 28/12/2023
  filter: {
    mainFilterFields: ["transactionType"],
    mainFilterValues: ["", ""],
    andFilterFields: [""],
    andFilterValues: [""],
  },
};

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data) {
  var newData = [];

  if (data.length === 0) {
    newData.push({
      id: "nothing",
      colum: [
        { label: "No Results", span: "" },
        { label: "", span: "" },
        { label: "", span: "" }
      ],
    });
    return newData;
  }

  data.forEach((elem) => {
    let newEntity;

    let customAvatarLetter = 'NA'; // Valor por defecto
    if (elem.transactionType === 'receivepayment') {
      newEntity = 'clientReceivepayment';
    } else if (elem.transactionType === 'sentpayment') {
      newEntity = 'clientSentpayment';
    }

    newData.push({
      id: elem.id,
      tdDataDetail: getTdDataDetail(newEntity, elem.transactionType, elem.id),
      colum: [
        {
          label: elem.accounts_name,
          span: elem.reference_number,
          style: {
            tdClass: 'tdWithAvatar',
            avatar: elem.accounts_avatar,
            avatarColor: elem.accounts_avatar_color,
            avatarColorLetter: elem.accounts_avatar_color_letter,
            avatarLetter: elem.accounts_avatar_letter

          }
        },

        { label: elem.amount_dt, span: timeDate.friendlyDate(elem.date_td) },

        {
          label: elem.paid_count,
          span: elem.paid_items,
        }
      ],
    }); /*push*/
  }); /*forEach*/

  return newData;
}